/**
 * Electronic wallet programs (CostaPass / "Monedero Electrónico") that a carrier can accept on a
 * given schedule. They are the values `available_wallets` can carry in the search payload, served
 * from `Ewallet::VALID_WALLET_TYPES` in platform-purchase.
 * @type {string[]}
 */
export const EWALLET_TYPES = ['costapass', 'travelpass'];

/**
 * Checks whether a single trip accepts the electronic wallet. The carrier reports it per schedule,
 * so two schedules of the same route can differ.
 * @param {object} trip - Trip from the search results.
 * @returns {boolean} True when the trip accepts the electronic wallet.
 */
export function tripAcceptsEwallet(trip) {
  const availableWallets = trip?.availableWallets;
  if (!Array.isArray(availableWallets)) return false;
  return availableWallets.some((wallet) => EWALLET_TYPES.includes(wallet));
}

/**
 * Checks whether a result list has at least one schedule that accepts the electronic wallet, which
 * is what makes the searched route a participating one.
 * @param {Array} trips - Trips rendered in the result list.
 * @returns {boolean} True when at least one trip accepts the electronic wallet.
 */
export function someTripAcceptsEwallet(trips) {
  if (!Array.isArray(trips)) return false;
  return trips.some(tripAcceptsEwallet);
}
